// Textos del widget del buscador en "en".
//
// GENERADO por scripts/f5-build/traducciones.js desde la tabla `traducciones`.
// No editar a mano: se regenera con
//     node scripts/f5-build/traducciones.js
//
// Van congelados en el bundle porque el widget no puede llamar a {tr} desde fuera de
// renfeviajes. Cambiar un rótulo exige rebuild y despliegue, no un UPDATE.
// Volcado: 2026-09-24 · 56 textos.

export const textos = {
  188: "Children",
  416: "From",
  7236: "Origin station",
  7237: "Destination station",
  7238: "Select a valid station",
  7239: "Children (0-13)",
  7240: "Children (0-3)",
  7241: "Without occupying a seat",
  7242: "Ready",
  7243: "Delete dates",
  7244: "Search",
  7245: "Passenger",
  7246: "Passengers",
  7247: "Search here for your product or city",
  7248: "Activity",
  7249: "Search hotel",
  7259: "Select a valid option",
  7331: "Train + Hotel / Leisure",
  7336: "Do you want to add a hotel to your trip?",
  7337: "No",
  7338: "Select passengers",
  7339: "Over 13 years old",
  7340: "From 0 to 13 years old",
  7341: "From 0 to 3 years old. They do not occupy a place",
  7386: "Train + Rental car",
  7388: "Driver's age",
  20012: "Warning",
  20013: "In packages with hotel, it is not possible to select the same day of departure and return.",
  20766: "Yes",
  20808: "To",
  20814: "Products",
  20815: "Destination",
  24531: "Nº of adults",
  24543: "Ages",
  24560: "Activity",
  24642: "Rooms",
  24643: "Room",
  24851: "Select",
  25940: "Room",
  25942: "Adults",
  25953: "1 Room, 2 Adults",
  25967: "hotel check out date",
  41044: "City",
  45897: "one way",
  45898: "Round trip",
  46510: "Cancel",
  46615: "No Return",
  46629: "choose schedules",
  46630: "ok",
  46641: "Choose",
  87088: "Round trip ticket",
  147090: "Hotel",
  344623: "One way ticket",
  1479751: "Train + Hotel + Leisure",
  1479756: "Hotel Check-in Date",
  1479757: "Hotel Departure Date",
  2011810: "From when until when do you want the car?",
}
